import TableCell from '@tiptap/extension-table-cell';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { TableCellRenderer } from '../components';

export const TableCellExtension = TableCell.extend({
  addNodeView() {
    return ReactNodeViewRenderer(TableCellRenderer, {
      as: 'td',
      className: 'tiptap-table-cell',
      stopEvent: () => false, // This is added to allow the cell to be selected & resized
    });
  },
});
